export {
  GRADING_THRESHOLDS,
  SPLIT_THRESHOLDS,
  STRUCTURE_EDITOR_BBX_THRESHOLDS,
  STRUCTURE_READONLY_ON_CONFIRM,
  SUBMISSION_READONLY_ON_CONFIRM,
} from '../../shared/constants.js';
